import React, { useEffect } from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { logEvent } from '../../utils/analytics';
import { useAuth } from '../auth/AuthContext';
import './PendingApprovalPage.css';

const PendingApprovalPage = () => {
  const { user, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  
  // 設置頁面標題
  useEffect(() => {
    logEvent('auth_gate_view', { status: 'pending' });
  }, []);

  useEffect(() => {
    document.title = '等待審核';
  }, []);

  // 檢查用戶狀態，如果已經激活，則重定向到首頁
  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        navigate('/');
      } else if (user && user.isActive) {
        navigate('/');
      }
    }
  }, [user, isAuthenticated, loading, navigate]);

  if (loading) {
    return (
      <Container className="my-5 pt-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">載入中...</span>
        </div>
        <p className="mt-3">載入中，請稍候...</p>
      </Container>
    );
  }

  return (
    <div className="pending-approval-container">
      <div className="pending-approval-content">
        <div className="pending-approval-header">
          <h2>帳號等待審核中</h2>
        </div>
        
        <div className="pending-approval-body">
          <Alert variant="info" className="mb-4">
            <Alert.Heading>您的帳號正在等待管理員審核</Alert.Heading>
            <p>
              您的個人資料已提交成功，目前正等待管理員審核。審核通過後，您將能夠存取所有功能。
            </p>
            <hr />
            <p className="mb-0">
              審核期間，您可以先瀏覽網站的公開內容。如有疑問，請與管理員聯絡。
            </p>
          </Alert>

          <div className="pending-approval-animation">
            <div className="animation-wrapper">
              <img 
                src="/images/gif/kaki.gif"
                alt="等待審核中"
                className="waiting-gif"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/avatar/乃木坂46.jpg";
                }}
              />
            </div>
            <p className="animation-caption">系統正在等待管理員審核您的帳號...</p>
          </div>

          <div className="text-center mt-4">
            <Button variant="outline-primary" onClick={() => navigate('/')}>
              返回首頁
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalPage;